import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';


@Component({
    selector: 'app-my-profile-paragraph',
    templateUrl: './my-profile-paragraph.component.html',
    styleUrl: './my-profile-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MyProfileParagraphComponent implements OnInit {
  public componentData: CmsParagraphComponent;

  

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
   
  }

 

}
